import { Box, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import ChildNoValueCell from 'components/DataGrid/ChildRows/ChildNoValueCell'
import { FC } from 'react'
import { DensityStyleTypes } from 'types'

interface GoogleAdsCellProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}

const GoogleAdsCell: FC<GoogleAdsCellProps> = ({ params, densityStyles }) => {
  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated) return
  if (!params?.row?.isParent) return <ChildNoValueCell densityStyles={densityStyles} />
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'left',
        alignItems: 'center',
        height: '100%',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
    >
      {params && params.value ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'left',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            gap: 1,
          }}
        >
          <Typography sx={{ fontSize: densityStyles.fontSize, overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {params.value}
          </Typography>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'left', overflow: 'hidden', textOverflow: 'ellipsis', gap: 1 }}>
          <Typography
            sx={{
              fontSize: densityStyles.fontSize,
              color: 'rgb(84, 81, 81)',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {'No Ads Id'}
          </Typography>
        </Box>
      )}
    </Box>
  )
}
export default GoogleAdsCell
